<script lang="ts">
    import { RuleEngine } from "../RuleEngine"

    // Choices from MailboxFilter
    export let currentChoices = null

    export let value: any = null
    export let name: string = null
    export let dependsOn: OfferAssistantDependsOnRule[]
    export let label: string
    export let placeholder: string
    export let defaultValue: string | number
    export let horizontal: boolean = false
    export let choices: {
        id: string | number
        title: string
    }[]
    export let values: { [key: string]: any }
    values = values || null

    const ruleEngine = new RuleEngine()
    let displayComponent: boolean = true

    if (!value) {
        value = defaultValue

        // Takeover selected mailbox total value from MailboxFilter(Konfigurator) and overwrite any default values
        if (currentChoices && currentChoices[name] && value !== currentChoices[name]) {
            value = currentChoices[name]
        }
    }

    $: if (dependsOn) {
        displayComponent = ruleEngine.resolve(dependsOn, values)
        if (!displayComponent) {
            value = null
        } else {
            if (!value && defaultValue) {
                value = defaultValue
            }
        }
    }
</script>

{#if displayComponent}
    <div class="radio-input">
        {#if label}
            <label for="">{label}</label>
        {/if}
        <div class="radio-input-choices" class:horizontal>
            {#each choices as choice}
                <label for="{name}_{choice.title}" class="radio-input-choice">
                    <input
                        type="radio"
                        id="{name}_{choice.title}"
                        name="{name}_{choice.title}"
                        bind:group="{value}"
                        value="{choice.id}"
                        {placeholder}
                    />
                    <span>{choice.title}</span>
                </label>
            {/each}
        </div>
    </div>
{/if}
